// Globals
import { useTranslation } from 'react-i18next';

// Modules
import { Header } from '@/modules/Layout';
import { selectChannel } from '@/modules/Channels';

// Store
import { useAppState } from '@/store';

// Components
import { UpdatePage } from '../../components/UpdatePage';
import { PagesStyledTable, StyledPagesContainerInner } from './PagesContainer.styles';

// Helpers
import { useGetPage } from '../../hooks/useGetPage';
import { useGetPages } from '../../hooks/useGetPages';
import { pagesTableColumns } from '../../utils/pagesTableColumns';

// Models
import { IBasePage } from '@/models/page.model';

export const PagesContainer = () => {
  const { t } = useTranslation(['common']);
  const currentChannel = useAppState(selectChannel);
  const { loadPage } = useGetPage();

  const { pages, isLoading: pagesIsLoading } = useGetPages(currentChannel?.id);

  return (
    <>
      <Header title={t('menu_pages_management')} />
      <StyledPagesContainerInner>
        <PagesStyledTable
          columns={pagesTableColumns(currentChannel?.id)}
          rowKey={'id'}
          dataSource={pages}
          loading={pagesIsLoading}
          pagination={false}
          rowHoverable
          onRow={(record: IBasePage) => ({
            onClick: () => {
              loadPage(record.type);
            },
          })}
        />
      </StyledPagesContainerInner>
      <UpdatePage />
    </>
  );
};
